import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

import { logo, logoSymbol, logoWhite, menu } from "@/assets";
import { Link, useLocation } from "react-router-dom";
import { sideNav } from "@/constants";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import {
  HiOutlineAcademicCap,
  HiOutlineHome,
  HiOutlineMoon,
} from "react-icons/hi2";
import { useTheme } from "@/hooks/useTheme";
import { CgMenuLeft, CgMenuRight } from "react-icons/cg";
import { MdOutlineGeneratingTokens } from "react-icons/md";
import { IoReceiptOutline, IoSettingsOutline } from "react-icons/io5";
import { AiOutlineDollar } from "react-icons/ai";
import { BsCart } from "react-icons/bs";
import { GoChevronDown } from "react-icons/go";
import { IoIosPeople } from "react-icons/io";

const MobileNav = () => {
  const [isActive, setIsActive] = useState("Home");
  const { theme, toggleTheme } = useTheme();
  const [closeTab, setCloseTab] = useState(false);

  const location = useLocation();
  const pathname = location.pathname;
  const realPathname = pathname.split("/")[2];

  useEffect(() => { }, [pathname]);

  return (
    <section className="w-full max-w-[264px] dark:text-white">
      <Sheet>
        <SheetTrigger>
          <CgMenuLeft size={30} />
        </SheetTrigger>

        <SheetContent
          side="left"
          className="border-none bg-white p-3 dark:bg-[#1A1D21F5] pt-10"
        >
          <SheetTitle>
            <Link
              href="/"
              className="flex w-32 cursor-pointer items-center gap-x-1"
            >
              <img src={logoSymbol} alt="logo" className="w-8" />

              <div className="flex w-full items-end gap-1">
                <h2 className="font-geist text-2xl font-bold text-black/85 dark:text-white">
                  Billzpay
                </h2>

                <span className="text-xs font-bold">V2.0</span>
              </div>
            </Link>
          </SheetTitle>

          <div className="dark:bg-darkBorder h-[1px] bg-gray-200" />

          <div className="mobilenav-sheet font-jakarta">
            <nav className="pt- flex h-full flex-col gap-2.5">
              <SheetClose asChild>
                <Link
                  to="/dashboard"
                  className={cn(
                    "flex items-center gap-2 rounded-lg px-3 py-2.5",
                    {
                      "text-primary bg-[#edf8f3] dark:bg-[#D7EDED29]":
                        pathname === "/dashboard",
                      "hover:bg-gray-100 hover:dark:bg-[#d7eded15]":
                        pathname !== "/dashboard",
                    },
                  )}
                >
                  <HiOutlineHome
                    size={21}
                    className="text-black/85 dark:text-[#CDE9DF]"
                  />

                  <h3 className="font-jakarta text-base font-semibold dark:text-white">
                    Home
                  </h3>
                </Link>
              </SheetClose>

              {sideNav.map((link) => {
                return (
                  <SheetClose
                    asChild
                    key={link.name}
                    className="mobilenav-sheet_close w-full"
                  >
                    <Link
                      to={link.route}
                      key={link.name}
                      onClick={() => scrollTo(0, 0)}
                      className={cn(
                        "mobilenav-sheet_close w-full rounded-lg px-3 py-2.5",
                        {
                          "text-primary bg-[#edf8f3] dark:bg-[#d7eded29]":
                            link.route === realPathname,
                          "hover:bg-gray-100 hover:dark:bg-[#d7eded15]":
                            link.route !== realPathname,
                        },
                      )}
                    >
                      <link.icon
                        size={24}
                        className="text-black/85 dark:text-[#CDE9DF]"
                      />
                      <p className={cn("text-16 font-medium dark:text-white")}>
                        {link.name}
                      </p>
                    </Link>
                  </SheetClose>
                );
              })}

              <div className="flex flex-col gap-1">
                <div
                  onClick={() => setCloseTab((prev) => !prev)}
                  className={cn("flex items-center rounded-lg px-3 py-2.5", {
                    "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                      realPathname === "order-history" ||
                      realPathname === "buy-exam-pins",
                    "hover:bg-gray-100 hover:dark:bg-gray-800":
                      realPathname !== "order-history",
                  })}
                >
                  <div className={cn("flex flex-1 items-center gap-2")}>
                    <HiOutlineAcademicCap
                      size={21}
                      className="text-black/85 dark:text-[#CDE9DF]"
                    />

                    <h3 className="text-base font-semibold dark:text-white">
                      Exam Pins & Tokens
                    </h3>
                  </div>

                  <GoChevronDown className="dark:text-white" />
                </div>

                {closeTab && (
                  <div
                    onClick={() => setCloseTab(false)}
                    className="flex flex-col gap-1"
                  >
                    <SheetClose asChild>
                      <Link
                        to="/dashboard/buy-exam-pins"
                        className={cn(
                          "ml-5 flex items-center gap-2 rounded-lg px-3 py-2.5",
                          {
                            "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                              realPathname === "buy-exam-pins",
                            "hover:bg-gray-100 hover:dark:bg-gray-800":
                              realPathname !== "buy-exam-pins",
                          },
                        )}
                        onClick={() => setIsActive("buy-exam-pins")}
                      >
                        <MdOutlineGeneratingTokens
                          size={21}
                          className="text-black/85 dark:text-[#CDE9DF]"
                        />
                        <h3 className="text-base font-semibold dark:text-white">
                          Buy Pins & Tokens
                        </h3>
                      </Link>
                    </SheetClose>

                    <SheetClose asChild>
                      <Link
                        to="/dashboard/order-history"
                        className={cn(
                          "ml-5 flex items-center gap-2 rounded-lg px-3 py-2.5",
                          {
                            "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                              realPathname === "order-history",
                            "hover:bg-gray-100 hover:dark:bg-gray-800":
                              realPathname !== "order-history",
                          },
                        )}
                        onClick={() => setIsActive("order-history")}
                      >
                        <BsCart
                          size={21}
                          className="text-black/85 dark:text-[#CDE9DF]"
                        />
                        <h3 className="text-base font-semibold dark:text-white">
                          Order History
                        </h3>
                      </Link>
                    </SheetClose>
                  </div>
                )}
              </div>

              {/* Beneficiaries */}
              <SheetClose asChild>
                <Link
                  to="/dashboard/beneficiaries"
                  className={cn(
                    "flex items-center gap-2 rounded-lg px-3 py-2.5",
                    {
                      "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                        realPathname === "beneficiary",
                      "hover:bg-gray-100 hover:dark:bg-gray-800":
                        realPathname !== "beneficiary",
                    },
                  )}
                  onClick={() => {
                    setIsActive("Beneficiary");
                    setCloseTab(false);
                  }}
                >
                  <IoIosPeople
                    size={21}
                    className="text-black/85 dark:text-[#CDE9DF]"
                  />
                  <h3 className="text-base font-semibold dark:text-white">
                    Beneficiaries
                  </h3>
                </Link>
              </SheetClose>

              {/* Fund Wallet */}
              <SheetClose asChild>
                <Link
                  to="/dashboard/fund-wallet"
                  className={cn(
                    "flex items-center gap-2 rounded-lg px-3 py-2.5",
                    {
                      "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                        realPathname === "fund-wallet",
                      "hover:bg-gray-100 hover:dark:bg-gray-800":
                        realPathname !== "fund-wallet",
                    },
                  )}
                  onClick={() => {
                    setIsActive("Fund Wallet");
                    setCloseTab(false);
                  }}
                >
                  <AiOutlineDollar
                    size={21}
                    className="text-black/85 dark:text-[#CDE9DF]"
                  />
                  <h3 className="text-base font-semibold dark:text-white">
                    Fund Wallet
                  </h3>
                </Link>
              </SheetClose>

              {/* Transaction */}
              <SheetClose asChild>
                <Link
                  to="/dashboard/transactions"
                  className={cn(
                    "flex items-center gap-2 rounded-lg px-3 py-2.5",
                    {
                      "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                        realPathname === "transactions",
                      "hover:bg-gray-100 hover:dark:bg-gray-800":
                        realPathname !== "transactions",
                    },
                  )}
                  onClick={() => setIsActive("Transactions")}
                >
                  <IoReceiptOutline
                    size={21}
                    className="text-black/85 dark:text-[#CDE9DF]"
                  />
                  <h3 className="text-base font-semibold dark:text-white">
                    Transactions
                  </h3>
                </Link>
              </SheetClose>

              {/* Settings */}
              <SheetClose asChild>
                <Link
                  to="/dashboard/account"
                  className={cn(
                    "flex items-center gap-2 rounded-lg px-3 py-2.5",
                    {
                      "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                        realPathname === "account",
                      "hover:bg-gray-100 hover:dark:bg-gray-800":
                        realPathname !== "account",
                    },
                  )}
                  onClick={() => {
                    setIsActive("Settings");
                    setCloseTab(false);
                  }}
                >
                  <IoSettingsOutline
                    size={21}
                    className="text-black/85 dark:text-[#CDE9DF]"
                  />
                  <h3 className="text-base font-semibold dark:text-white">
                    Settings
                  </h3>
                </Link>
              </SheetClose>
            </nav>
          </div>

          <SheetFooter>
            <Footer />
          </SheetFooter>
        </SheetContent>
      </Sheet>
    </section>
  );
};

export default MobileNav;
